<template>
  <div
    class="image-compare-container"
    style="position: relative; width: 100%; height: 100%; overflow: hidden; user-select: none;"
    @mousedown="startDrag"
    @touchstart="startDrag"
    @mousemove="dragging && onDrag($event)"
    @touchmove="dragging && onDrag($event)"
    @mouseup="stopDrag"
    @touchend="stopDrag"
  >
    <!-- Right image as full background, not resized -->
    <img
      :src="rightImage"
      :alt="rightAlt"
      class="image-compare-img"
      style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: cover; object-position: left top; pointer-events: none;"
    />
    <!-- <div
      :style="{ width: '100%', overflow: 'hidden', position: 'absolute', top: 0, left: 0, height: '100%' }"
    >
      <img
        :src="rightImage"
        :alt="rightAlt"
        class="image-compare-img"
        style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: cover; object-position: left top; pointer-events: none;"
      />
    </div> -->
    <!-- Left image cropped by container width, not resized -->
    <div
      :style="{ width: position + '%', overflow: 'hidden', position: 'absolute', top: 0, left: 0, height: '100%' }"
    >
      <img
        :src="leftImage"
        :alt="leftAlt"
        class="image-compare-img"
        style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: cover; object-position: left top; pointer-events: none;"
      />
    </div>
    <!-- Draggable handle -->
    <div
      :style="{
        position: 'absolute',
        top: 0,
        left: position + '%',
        transform: 'translateX(-50%)',
        height: '100%',
        width: '4px',
        background: 'orange',
        cursor: 'ew-resize',
        zIndex: 2
      }"
      @mousedown.prevent="startDrag"
      @touchstart.prevent="startDrag"
    >
      <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); background: white; border-radius: 50%; width: 32px; height: 32px; border: 2px solid orange; display: flex; align-items: center; justify-content: center;">
        <svg width="16" height="16" fill="none" stroke="orange" stroke-width="2" viewBox="0 0 24 24">
          <path d="M9 4v16M15 4v16"/>
        </svg>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'

export default defineComponent({
  name: 'ImageCompare',
  props: {
    leftImage: { type: String, required: true },
    rightImage: { type: String, required: true },
    leftAlt: { type: String, default: '' },
    rightAlt: { type: String, default: '' }
  },
  setup(props) {
    const position = ref(50)
    const dragging = ref(false)

    const onDrag = (e: MouseEvent | TouchEvent) => {
      let clientX = 'touches' in e ? e.touches[0].clientX : e.clientX
      const container = (e.target as HTMLElement).closest('.image-compare-container')
      if (container) {
        const rect = container.getBoundingClientRect()
        let percent = ((clientX - rect.left) / rect.width) * 100
        percent = Math.max(0, Math.min(100, percent))
        position.value = percent
      }
    }

    const startDrag = () => {
      dragging.value = true
      window.addEventListener('mousemove', onDrag)
      window.addEventListener('touchmove', onDrag)
      window.addEventListener('mouseup', stopDrag)
      window.addEventListener('touchend', stopDrag)
    }

    const stopDrag = () => {
      dragging.value = false
      window.removeEventListener('mousemove', onDrag)
      window.removeEventListener('touchmove', onDrag)
      window.removeEventListener('mouseup', stopDrag)
      window.removeEventListener('touchend', stopDrag)
    }

    return { position, dragging, startDrag, stopDrag, onDrag }
  }
})
</script>

<style scoped>
.image-compare-img {
  /* Prevent image resizing, show original size, crop by container */
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: none;
  object-position: left top;
  pointer-events: none;
}
</style>
